import numeral from 'numeral';
import { format } from 'date-fns';

const phoneLengthMinimum = 10;

const isValidPhone = (phoneNumber) => {
  return !(!phoneNumber || !phoneNumber.match(/\d/g, '') || phoneNumber.match(/\d/g, '').length < phoneLengthMinimum);
};

const FormatLogic = {
  money: (amount) => {
    return numeral(amount).format('$0,0');
  },
  monthDayYear: (date) => {
    return format(date, 'MMMM D, YYYY');
  },
  monthDayYearShort: (date) => {
    return format(date, 'MM/DD/YYYY');
  },
  localTimeFromDate: (date) => {
    return format(date, 'h:mma');
  },
  phone: (phoneNumber = '', isMasked = false) => {
    if (!isValidPhone(phoneNumber)) {
      return '';
    }

    let pn = phoneNumber;
    pn = pn.match(/(\d|[ext])/g, '').join('');

    let areaCode = pn.substring(0, 3);
    let prefix = pn.substring(3, 6);
    let postfix = pn.substring(6);

    if (isMasked) {
      areaCode = areaCode.substring(0, 2) + '*';
      prefix = '***';
      postfix = postfix.substring(0, 1) + '***';
    }

    const extensionIndex = postfix.search(/\d[ex]/) + 1;
    if (extensionIndex && !isMasked) {
      postfix = postfix.substring(0, extensionIndex) + ' ' + postfix.substring(extensionIndex);
    }

    let result = '';

    if (areaCode) {
      result = `(${areaCode}${prefix ? ')' : ''}`;
    }

    if (prefix) {
      result = `${result} ${prefix}${postfix ? '-' : ''}`;
    }

    return result + postfix;
  },
  monthlyIncome: (amount) => {
    return `${numeral(amount).format('$0,0')}/mo`;
  },
  maskedEmail: (email) => {
    if (!email) {
      return '';
    }

    const emailComponents = email.split('@');
    if (emailComponents.length !== 2) {
      return '';
    }

    const userName = emailComponents[0];
    const domain = emailComponents[1];

    const maskedUsername = userName[0] + '*****' + userName.slice(-1);

    const domainComponents = domain.split('.');
    let maskedDomain;
    if (domainComponents.length < 2) {
      maskedDomain = '******';
    } else {
      maskedDomain = '******.' + domainComponents.slice(-1);
    }

    return maskedUsername + '@' + maskedDomain;
  },
};

export const formatApplicantsNames = ({
  applicants = [],
  defaultText,
  defaultTextPlural,
  addPossessiveAffixExcludingDefaults = false,
}) => {
  if (!applicants) {
    return defaultText;
  }
  let applicantsFirstNames = applicants.map(
    (applicant) =>
      // If data is from direct response.
      applicant?.firstName ||
      // If data is through GraphQL query.
      applicant?.contactInfo?.firstName,
  );

  if (applicantsFirstNames.some((name) => !name)) {
    // If any name is missing, return given default text.
    if (applicantsFirstNames.length > 1 && defaultTextPlural) {
      return defaultTextPlural;
    }

    if (defaultText) {
      return defaultText;
    }
  }

  const posssiveAffixIfApplicable = addPossessiveAffixExcludingDefaults ? "'s" : '';
  let preAffixFormattedNames = '';
  if (applicantsFirstNames.length === 1) {
    preAffixFormattedNames = `${applicantsFirstNames[0]}`;
  } else if (applicantsFirstNames.length === 2) {
    preAffixFormattedNames = `${applicantsFirstNames[0]} and ${applicantsFirstNames[1]}`;
  } else if (applicantsFirstNames.length > 2) {
    let lastApplicant = applicantsFirstNames.pop();
    preAffixFormattedNames = `${applicantsFirstNames.join(', ')}, and ${lastApplicant}`;
  }
  return preAffixFormattedNames + posssiveAffixIfApplicable;
};

export const getTitleCase = (string) => {
  if (!string) {
    return '';
  }
  return string
    .split(' ')
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
};

export default FormatLogic;
